import React from 'react';
import SelectCatProduitsView from './SelectCatProduit.view';
import { ProductCategory } from '../../types/product/product';

interface SelectCatProduitsProps {
  categories?: Array<ProductCategory>;
}

const SelectCatProduits = ({ categories }: SelectCatProduitsProps) => {
  return <SelectCatProduitsView categories={categories} />;
};
export default SelectCatProduits;
